import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Login from "./Components/Login";
import Register from "./Components/Register";
import ForgotPassword from "./Components/ForgotPassword";
import ForgotPasswordVerify from "./Components/ForgotPasswordVerify";
import ChangePasswordConfirm from "./Components/ChangePasswordConfirm";
import QuantumCryptoLanding from "./Components/QuantumCryptoLanding";

import {
  Container,
  SubContainer,
  Logo,
  PageWrapper
} from "./authStyle";

import logo from "../../assets/newLogo.png";

export default function AuthMain() {
  const [height, setHeight] = useState(540);
  const [slideUp, setSlideUp] = useState(false);

  // Ensure the page scrolls to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Create the auth component to pass to QuantumCryptoLanding
  const authComponent = (
    <SubContainer height={height} slideUp={slideUp}>
      <Logo src={logo} alt="logo" />
      <Router>
        <Switch>
          <Route
            exact
            path="/register"
            render={(props) => (
              <Register
                {...props}
                setHeight={setHeight}
                onSignIn={() => setSlideUp(true)}
              />
            )}
          />
          <Route exact path="/forgotPassword" component={ForgotPassword} />
          <Route
            exact
            path="/forgotPasswordVerify"
            render={(props) => (
              <ForgotPasswordVerify {...props} setHeight={setHeight} />
            )}
          />
          <Route
            exact
            path="/changePasswordConfirm"
            render={(props) => (
              <ChangePasswordConfirm {...props} setHeight={setHeight} />
            )}
          />
          <Route
            render={(props) => (
              <Login
                {...props}
                onSignIn={() => setSlideUp(true)}
                setHeight={setHeight}
              />
            )}
          />
        </Switch>
      </Router>
    </SubContainer>
  );

  return (
    <PageWrapper>
      <Container>
        <QuantumCryptoLanding authComponent={authComponent} />
      </Container>
    </PageWrapper>
  );
}